var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F6F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.75C12.4142 4.75 12.75 5.08579 12.75 5.5V7.5C12.75 7.91421 12.4142 8.25 12 8.25C11.5858 8.25 11.25 7.91421 11.25 7.5V5.5C11.25 5.08579 11.5858 4.75 12 4.75Z",
    fill: "#898EA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99989 6.16602H14C14.5523 6.16602 15 6.61373 15 7.16602V9.49939C15 10.0517 14.5523 10.4994 14 10.4994C13.4477 10.4994 13 10.9471 13 11.4994V17.166C13 17.7183 12.5522 18.166 11.9999 18.166C11.4477 18.166 10.9999 17.7183 10.9999 17.166V9.49939C10.9999 8.9471 10.5522 8.49939 9.99989 8.49939C9.44761 8.49939 8.99989 8.05167 8.99989 7.49939V7.16602C8.99989 6.61373 9.44761 6.16602 9.99989 6.16602Z",
    fill: "#898EA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.5C18 11.9477 17.5523 11.5 17 11.5H15C14.4477 11.5 14 11.9477 14 12.5V17.1667C14 17.719 14.4477 18.1667 15 18.1667H17C17.5523 18.1667 18 17.719 18 17.1667V12.5Z",
    fill: "#898EA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.0744C6 11.7188 6.18891 11.3899 6.49613 11.2106L8.49613 10.044C9.16279 9.65509 10 10.136 10 10.9078V17.1667C10 17.719 9.55228 18.1667 9 18.1667H7C6.44772 18.1667 6 17.719 6 17.1667V12.0744Z",
    fill: "#898EA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/accountIcon.21a5c7f2e7c7dc1bbbc9cc1afcbac0c8.svg";
export { ForwardRef as ReactComponent };